import GenerateServiceRequestModal from './generate-sr-modal.container'

export default GenerateServiceRequestModal